module.exports = __webpack_public_path__ + "static/1-2adcc262b541be5d259a9121651a06f3.jpg";